import React, { useState, useEffect, Fragment } from 'react'
import { useShared } from '../../hooks/useShared'
import AMenu from '../../components/partials/AMenu';
import { useParams } from 'react-router-dom';
import MainSection from '../../components/sections/MainSection';
import { Chip } from '@material-tailwind/react';


const TABLE_HEAD = ["#", "نوعيت مصرف", 'مقدار پول', "بودجه", "از تاريخ - الی تاريخ", "حالت", 'تاريخ ايجاد', 'اقدامات'];
const breadcrumbs = [{ name: 'مصارف', link: null }]
const menuData = [
 /*  {flag:"Upload File", name: 'آپلود قايل', icon: 'cloud-upload-outline', roles: [1, 2,20] }, */
  {flag:"Approve", name: 'تایید', icon: 'checkmark-done-outline', roles: [1, 2,20] },
  {flag:"Edit", name: 'ايرايش', icon: 'create-outline', roles: [1, 2,20] },
  {flag:"Delete", name: 'حذف', icon: 'trash-outline', roles: [1,2,20] },
]


const searchInputFields = [
  { label: 'نوعيت مصرف', name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3' },
  { label: 'بودجه', name: 'budget_type', type: 'select', roles: [1], icon: 'text-outline', className: 'md:col-span-3', },
  { label: 'مقدار پول', name: 'amount', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-2', },
  { label: 'از تاريخ', name: 'from_date', type: 'pdate', roles: [1], icon: 'book-outline', className: 'md:col-span-2' },
  { label: 'الی تاريخ', name: 'to_date', type: 'pdate', roles: [1], icon: 'book-outline', className: 'md:col-span-2' },
];


const newModelInputFields = [
  { label: 'نوعيت مصرف', name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: '', required: 'The name is requieed', isStyle: false },
  {
    label: 'بودجه', name: 'budget_type', type: 'select', roles: [1], icon: 'text-outline', className: '', required:false,
    options: []
  },
  { label: 'مقدار پول', name: 'amount', type: 'number', roles: [1], icon: 'text-outline', className: '', required: 'The amount is requieed', isStyle: false },
  { label: 'از تاريخ ', name: 'from_date', type: 'pdate', roles: [1], icon: 'text-outline', className: '', required: false, isStyle: false },
  { label: 'الی تاريخ ', name: 'to_date', type: 'pdate', roles: [1], icon: 'text-outline', className: '', required: false, isStyle: false },

  { label: 'ملاحظات', name: 'description', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false, isStyle: false },

];

const csvHeaders = [
  { label: "#", key: "index" },
  { label: "نام", key: "name" },
  { label: "مقدرا بول", key: "amount" },
  { label: "بودجه", key: "budget_type" },
  { label: "از تاريخ", key: "from_date" },
  { label: "الی تاريخ", key: "to_date" },
  { label: "تاريخ ايحاد", key: "date" },
  { label: "حالت", key: "status" },
  { label: "ايجاد کننده", key: "creator_id" },
];


export default function Expenses() {

  const params = useParams();
  const { http, com,setModel, models, auth, navigate, setOpenApproveDialog, setShowNewModelDialog, setOpenUploadFileDialog,showDeleteDialog, setShowDeleteDialog } = useShared();

    useEffect(() => {
      if (!auth.hasRole([1,2,20])) {
          return navigate("/db/notAllowed")
      }
    }, [])

  useEffect(() => {
    http.post(`/api/budgetsAdvanceSearch?nameId=true`).then(res => {
      console.log('get budget ', res);
      if (res.data.success) {
        newModelInputFields[1].options = res.data.data
      }
    })

  }, [newModelInputFields[1].options])

  console.log("params ", params);


  const handleMenu = (model, flag = false) => {
    console.log("handleMenu ", model, flag);

    if (flag === 'delete') {
      setModel(model)
      setShowDeleteDialog(!showDeleteDialog)
    }
    if (flag === 'edit') {
      setModel(model)
      setShowNewModelDialog(true)
    }
    if (flag === "upload file") {
      console.log("upload file");
      setModel(model)
      setOpenUploadFileDialog(pre => !pre)
    }
    if (flag === "approve") {
      console.log(flag);
      setModel(model)
      setOpenApproveDialog(pre => !pre)
  }
  };


  const handleViewDialog = (obj) => {
    return [
      { l: 'Name', v: obj?.name },
      { l: 'Type', v: obj?.parent?.label },
      { l: 'Description', v: obj?.description },
      { l: 'Added by', v: obj?.user?.full_name },
      { l: 'Status', v: obj?.status },
      { l: 'Last Update', v: com.ddmmyyhhmmA(obj?.updated_at) },
    ]
  }

  const getTableData = () => {
    const data = models?.data
    return (<><tbody className=''>
      {models?.data?.map((r, i) => {
        return (<Fragment key={r.id}>
          {i < data?.length - 1 &&
            <tr key={r.id}>
              <td >{models?.from + i}</td>

              <td className='!p-1'> {r.name} </td>
              <td >{com.NumberFormatter(r?.amount)} ؋</td>
              <td >{r?.budget_type?.label}</td>
              <td >{com.getDate(r?.from_date)} - {com.getDate(r?.to_date)} </td>
              <td> <Chip className='capitalize text-center px-1' variant="ghost" size="sm" color={r.status === 0 ? 'orange'
                : r.status === 2 ? 'green' : 'red'}
                value={r.status === 0 ? 'Pending Aproval'
                  : r.status === 2 ? 'Completed'
                    : 'Rejected'} />  </td>
            
              <td  style={{direction:'ltr'}}>{com.dateConvert(r?.created_at, false, true)}
              <p>{r?.user?.full_name}</p>
              
              </td>
              <td >
                <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), row: r, menuData }} />


              </td>
            </tr>}</Fragment>)
      })}
    </tbody><tfoot>
        {data?.length > 0 && <tr className='border' key={data[data?.length - 1]?.id}>
          <th className="bg-purple-500/20 text-purple-900"> توتال</th>
          <th colSpan={8} className=" bg-green-400/30 text-green-900 text-lg font-bold">{com.NumberFormatter(data[data?.length - 1]?.amount)} ؋</th>
        </tr>}
      </tfoot></>)
  }

  return (
      <MainSection v={{
        handleViewDialog,
        newModelInputFields,
        searchInputFields,
        TABLE_HEAD,
        breadcrumbs,
        tableData: getTableData(),
        modelName: { name: 'expenses', af: 'مصارف' },
        mUrl: { delete: 'expenses', create: 'expenses', getAll: 'expensesAdvanceSearch' },
        url: 'expenses',
        addNewItemTitle: "مصرف جديد",
        attachName: 'مصارف جديد',
        tableTitle: 'لیست مصارف',
        newModelDialogClassName: "h-[85%]",
        searchData: { budget_type: { value: params.id } },
        csv: { csvHeaders, show: true }
      }} />
  )
}
